import { createSlice, createAsyncThunk, PayloadAction } from '@reduxjs/toolkit';
import { logoRequestListService } from "./logoRequestAPI";
import { LogoRequest } from "./logoRequestList.types";
import { stat } from 'fs';

/**
 * Logo request state
 */
interface LogoRequestState {
    requestListCertificateId: string;
    logoRequestList: LogoRequest[];
    logoRequestListloading: boolean;
    logoRequestError: string | null;
}

/**
 * Logo request inital state
 */
const initialState: LogoRequestState = {
    requestListCertificateId: '',
    logoRequestList: [],
    logoRequestListloading: false,
    logoRequestError: null,
};

/**
 * Thunks for fetching logo request
 */
export const fetchLogoRequests = createAsyncThunk('logoRequestList/fetch',
    async (certificateId: string, thunkAPI) => {
        try {
            return await logoRequestListService.fetchLogoRequests(certificateId);
        } catch (error: any) {
            const message = error.message || 'Failed to fetch logo requests';
            return thunkAPI.rejectWithValue(message);
        }
    });

/**
 *  Logo request slice
 */
const logoRequestListSlice = createSlice({
    name: 'logoRequests',
    initialState,
    reducers: {
        // Local (synchronous) reducers
        clearData: (state) => {
            Object.assign(state, initialState); // resets entire slice to initialState
        },
        updateLogoRequest(state, action: PayloadAction<LogoRequest>) {
            const index = state.logoRequestList.findIndex(logoRequest => logoRequest.requestId === action.payload.requestId);
            if (index !== -1) {
                state.logoRequestList[index] = action.payload;
            }
        },
        createRequest(state, action: PayloadAction<LogoRequest>) {
           state.logoRequestList.push(action.payload);
        }
    },
    extraReducers: builder => {
        // These handle async actions (like fetchUsers thunk)
        builder
            .addCase(fetchLogoRequests.pending, state => {
                state.logoRequestListloading = true;
                state.logoRequestError = null;
            })
            .addCase(fetchLogoRequests.fulfilled, (state, action) => {
                const args = action.meta.arg;
                state.requestListCertificateId = args;
                state.logoRequestList = action.payload;
                state.logoRequestListloading = false;
            })
            .addCase(fetchLogoRequests.rejected, (state, action) => {
                state.logoRequestError = action.payload as string;
                state.logoRequestListloading = false;
            })
    }
});

export const { updateLogoRequest, createRequest} = logoRequestListSlice.actions;
export default logoRequestListSlice.reducer;